import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useAcademicYears = (params = {}, queryOptions = {}) => {
  const queryParams = new URLSearchParams({
    page: String(params.page || 1),
    limit: String(params.limit || 100),
    sort: params.sort || "startDate",
    order: params.order || "DESC",
    ...(params.search && { search: params.search }),
    ...(params.instituteId && { instituteId: String(params.instituteId) }),
  });

  return useQuery({
    queryKey: ["academicYears", params],
    queryFn: async () => {
      const response = await api.get(`/academic-info/all?${queryParams.toString()}`);
      return response?.data?.data?.academicYears || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...queryOptions,
  });
};
